import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router';
import { router } from './router';
import { MusicPlayer } from '../components/MusicPlayer';
import { TransitionHost } from '../components/transition/TransitionHost';

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 60_000 } },
});

export function Root() {
  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      {/* Deliberately outside RouterProvider: the transition overlay has to
          outlive the route swap it exists to cover. See components/transition/. */}
      <TransitionHost />
      <MusicPlayer />
    </QueryClientProvider>
  );
}
